import { createWidgetModuleExportName } from '../createWidgetModuleExportName.js';
import { createFailure, isFailure } from '../OperationResult.js';
import { tryExecute } from '../tryExecute.js';
import { getFetchMessage } from './getFetchMessage.js';
export var ImportWidgetModuleFromNamespaceFaultType;
(function (ImportWidgetModuleFromNamespaceFaultType) {
    ImportWidgetModuleFromNamespaceFaultType["NoExport"] = "no-export";
})(ImportWidgetModuleFromNamespaceFaultType || (ImportWidgetModuleFromNamespaceFaultType = {}));
function createImportFailure(type, message) {
    return createFailure({ type, message });
}
export async function importWidgetModuleFromNamespace(importNamespaceResult, widgetUrl, dependencies) {
    if (isFailure(importNamespaceResult)) {
        return createFailure({
            type: 'module-load-failed',
            message: `Failed to load module '${widgetUrl}': '${importNamespaceResult.fault}'`,
            fetchMessage: await getFetchMessage(widgetUrl),
        });
    }
    const { value } = importNamespaceResult;
    if (!value) {
        return createImportFailure(ImportWidgetModuleFromNamespaceFaultType.NoExport, `Module '${widgetUrl}' has no namespace`);
    }
    const createWidgetModule = value[createWidgetModuleExportName];
    if (!createWidgetModule) {
        return createImportFailure(ImportWidgetModuleFromNamespaceFaultType.NoExport, `Namespace '${JSON.stringify(value)}' have no '${createWidgetModuleExportName}' export`);
    }
    if (typeof createWidgetModule !== 'function') {
        return createImportFailure(ImportWidgetModuleFromNamespaceFaultType.NoExport, `Export '${createWidgetModuleExportName}' is not a function: '${createWidgetModule}'`);
    }
    return await tryExecute(() => createWidgetModule({ dependencies }));
}
